// 「利用申請受付機能について」のヘルプ
const HELP_URL = 'https://help.codmon.com/facility/facility-manual/18811';

/**
 * 連絡即予定反映の注意書きディレクティブ
 *
 * 学童かつ利用申請ONにすると、保護者からの連絡が送信された時点で予定へ反映されることを、設定を変更する前に伝える。
 * 連絡即予定反映の段階リリースの経路が成立する施設にだけ表示する（施設種別・利用申請の現在値では出し分けない）。
 * 経路の判定が出るまでは表示せず、判定に失敗したときも表示しない。親のスコープには依存しない。
 * 表示しないときに余白が残らないよう、Bootstrap の row / col も表示時だけ出力する。
 *
 * 使用例（ラベル列が3カラムの行の下に置く場合）:
 * <contact-to-schedule-apply-notice label-columns="3"></contact-to-schedule-apply-notice>
 *
 * @param {string=} labelColumns 注意書きの左に空けるカラム数（1〜11）。省略時は3
 */
angular.module('inspinia').directive('contactToScheduleApplyNotice', [
  'parentContactsService',
  '$window',
  '$q',
  function (parentContactsService, $window, $q) {
    return {
      restrict: 'E',
      scope: {
        labelColumns: '@?',
      },
      templateUrl:
        '/manage/src/view/directive/project/parentContacts/contact_to_schedule_apply_notice.html?' +
        new Date().getTime(),
      link: function (scope) {
        scope.isVisible = false;

        scope.offsetColumns = function () {
          var columns = parseInt(scope.labelColumns, 10);
          return columns >= 1 && columns <= 11 ? columns : 3;
        };

        $q.when(parentContactsService.isContactToScheduleApplyFlagPathOpen())
          .then(function (isOpen) {
            scope.isVisible = isOpen === true;
          })
          .catch(function () {
            scope.isVisible = false;
          });

        // ヘルプを新しいタブで開く。開き元を渡さないよう noopener にする
        scope.openHelp = function () {
          $window.open(HELP_URL, '_blank', 'noopener');
        };
      },
    };
  },
]);
